/**
 * @typedef {object} PlayerModalState
 * @property {any} data
 * @property {boolean} visible
 * @property {any} playerId
 * @property {any} seasonId
 * @property {any} season
 * @property {object} leaderBoardData
 * @property {object} predicted
 *
 */
